import {
  StyleRulesCallback,
  WithStyles,
  withStyles as withStylesCb
} from "@material-ui/core/styles";

export const styles: StyleRulesCallback = ({ typography }) => ({
  container: {
    whiteSpace: "nowrap"
  },
  ratingText: {
    fontWeight: typography.fontWeightRegular
  }
});

export type Styles = WithStyles<typeof styles>;
export const withStyles = withStylesCb(styles);
